import { toast } from 'react-toastify';

import { apolloClient } from 'App';
import { formatDateAsAnniversary } from 'helpers/dateTimes';
import { ProductArrangementsToUpdate } from './types';

import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';
import {
    GetMenuProductArrangementsQuery,
    GetMenuProductArrangementsQueryVariables,
    useUpdateMenuProductArrangementsMutation,
} from 'data/__generated__';
import { GET_MENU_PRODUCT_ARRANGEMENTS_QUERY } from 'data/queries/menus';

export function UpdateMenuProductArrangementsButton({
    date,
    productArrangementsToUpdate,
    resetProductArrangementsToUpdate,
}: {
    date: Date;
    productArrangementsToUpdate: ProductArrangementsToUpdate;
    resetProductArrangementsToUpdate: () => void;
}) {
    const [updateMenuProductArrangements, { loading }] = useUpdateMenuProductArrangementsMutation();

    async function handleClick() {
        const formattedProductArrangementsToUpdate = Object.entries(productArrangementsToUpdate).flatMap(
            ([productArrangementId, productArrangement]) =>
                Object.entries(productArrangement).flatMap(([productArrangementIndex, productArrangement]) =>
                    Object.entries(productArrangement).flatMap(([rotationNumber, productArrangement]) => {
                        return {
                            productArrangementId,
                            productArrangementIndex: parseInt(productArrangementIndex), // because javascript convert keys to string...
                            rotationNumber: parseInt(rotationNumber), // because javascript convert keys to string...
                            currentProductId: productArrangement.currentProduct?._id || null,
                            newProductId: productArrangement.newProduct?._id || null,
                        };
                    }),
                ),
        );
        try {
            await updateMenuProductArrangements({
                variables: {
                    productArrangementsToUpdate: formattedProductArrangementsToUpdate,
                    date: formatDateAsAnniversary({ dateTime: date, useNewFormat: true }),
                },
                onCompleted: ({ updateMenuProductArrangements: updatedMenuProductArrangements }) => {
                    apolloClient.writeQuery<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>({
                        query: GET_MENU_PRODUCT_ARRANGEMENTS_QUERY,
                        variables: {
                            date: formatDateAsAnniversary({ dateTime: date, useNewFormat: true }),
                        },
                        data: { menuProductArrangements: updatedMenuProductArrangements },
                    });
                    toast.success('Les menus ont bien été mis à jour');
                    resetProductArrangementsToUpdate();
                },
                onError: (error) => {
                    toast.error(`Impossible de mettre à jour les menus: ${error}`);
                },
            });

            // update client with updated SiteMenusFromPrediction
        } catch (error) {
            toast.error(`Impossible de mettre à jour les menus: ${error}`);
            throw Error('Impossible de mettre à jour les menus');
        }
    }

    const disabled = Object.keys(productArrangementsToUpdate).length === 0;

    return (
        <TotemPrimaryLoadingButton
            $minWidth="240px"
            loading={loading}
            disabled={disabled || loading}
            onClick={handleClick}
            label="Enregistrer"
        />
    );
}
